module.exports = __webpack_public_path__ + "7ef472c9b2d42e81f2cb63961b0e1bb4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/profiles/profile/basic/edit/edit.html
// module id = 2523
// module chunks = 0